import { KrakenSuggestionEvent } from "../types/kraken";

export function sendKrakenEvent(searchTerm: string): void {
    const eventData: KrakenSuggestionEvent = {
        version: 1,
        eventDate: new Date().toISOString(),
        eventId: crypto.randomUUID(),
        context: {
            senderId: "ESPP2.ShopSearchWeb"
        },
        type: "SearchSuggestions",
        properties: {
            searchTerm: searchTerm
        }
    };
    shell?.messageBroker.publishTo("kraken.searchsuggestions", eventData);
}
